import { render, staticRenderFns } from "./canvas-player.vue?vue&type=template&id=ccb497a4&scoped=true&"
import script from "./canvas-player.vue?vue&type=script&lang=js&"
export * from "./canvas-player.vue?vue&type=script&lang=js&"
import style0 from "./canvas-player.vue?vue&type=style&index=0&id=ccb497a4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccb497a4",
  null
  
)

export default component.exports